import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ResetPassword = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error('Le password non coincidono'); return; }
    if (password.length < 6) { toast.error('Min 6 caratteri'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      toast.success('Password aggiornata, ora accedi');
      navigate('/');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return <div className="min-h-screen flex items-center justify-center text-slate-600">Token mancante</div>;

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6">
      <Card className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-lg" data-testid="reset-password-card">
        <CardHeader>
          <CardTitle className="text-2xl text-[#0F172A]">Nuova password</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label>Nuova password</Label>
              <Input data-testid="reset-pw-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-lg" />
            </div>
            <div>
              <Label>Conferma password</Label>
              <Input data-testid="reset-pw-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="rounded-lg" />
            </div>
            <Button type="submit" data-testid="reset-submit-btn" disabled={loading} className="w-full bg-[#EA580C] hover:bg-[#EA580C]/90 text-white rounded-lg">
              {loading ? 'Salvataggio...' : 'Imposta password'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ResetPassword;
